import styled from '@emotion/styled';

export const StyledContainer = styled.div<{ hasMarginTop?: boolean }>`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  margin-top: ${({ hasMarginTop }) => (hasMarginTop ? '10rem' : 'none')};
`;
